import { query, space } from '@design/templateFns';
import styled, { css } from 'styled-components';

export const GridContainer = styled.div<{ $amount: number }>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${space('lg')};
  margin-top: ${space('x10')};
  margin-bottom: ${space('x10')};

  @media screen and (${query.atLeast('desktop')}) {
    gap: ${space('x5')};
  }

  > div:first-child {
    grid-column: span 2;
  }

  ${({ $amount }) =>
    $amount === 2 &&
    css`
      > div {
        grid-column: span 2;
      }
    `}
`;
